import BasicInput from "../../BasicInput";
import { colors } from "../../../data/colors";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { stdObject } from "../../../data/types/stdObject";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { SetStateAction, useRef, useState } from "react";
import { useMainContext } from "../../../context/MainContext";
import { emptys } from "../../../data/main";
import OfferDay from "./OfferDay";
import { deleteOffer } from "../../../screens/MainFrame/functions/item/deleteOffer";
import { updateOffer } from "../../../screens/MainFrame/functions/item/updateOffer";

export default function OffersRow({
  data = {},
  country,
  active,
  index,
}: stdObject) {
  const { t } = useTranslation();
  const dateRef = useRef<HTMLInputElement>(null);
  const { windowValues2, setWindowValues2 } = useMainContext();
  const [temp, setTemp] = useState<stdObject>(data);
  const pricesRates: Array<stdObject> = useSelector(
    (state: RootState) => state.data.tar,
  );

  const updateOfferRowData = (
    key: string,
    value: any,
    dayIndexs?: Array<number> | number,
  ) => {
    if (["DATES", "DAYS", "WEEK"].includes(key) && !(key in temp)) {
      temp[key] = [];
    }

    if (["DATES", "WEEK"].includes(key) && typeof dayIndexs === "number") {
      temp[key][dayIndexs] = value;
      if (key === "DATES") {
        if (emptys.includes(value) && (temp[key].length === 1 || dayIndexs)) {
          temp[key].splice(dayIndexs, 1);
        }
      }
    }

    if (key === "DAYS") {
      if (Array.isArray(dayIndexs)) {
        if (!temp[key][dayIndexs[0]]) {
          temp[key][dayIndexs[0]] = [];
        }
        if (emptys.includes(value)) {
          if (dayIndexs[1]) {
            temp[key][dayIndexs[0]].splice(dayIndexs[1], 1);
          } else {
            temp[key].splice([dayIndexs[0]], 1);
          }
        } else {
          temp[key][dayIndexs[0]][dayIndexs[1]] = value;
        }
      } else {
        temp[key].push(value);
      }
    }

    if (["DATES", "DAYS", "WEEK"].includes(key)) {
      value = temp[key];
    }

    let innerTemp = { [key]: value };
    updateOffer(country, index, innerTemp, { windowValues2 });
    setTemp({ ...temp, ...innerTemp });
    return true;
  };

  const datesInputs = () => {
    switch (Number(temp.DATOFE)) {
      case 1:
        return Array.from({ length: 2 }, (_, idx) => (
          <BasicInput
            key={idx}
            type={"date"}
            value={temp.DATES ? temp.DATES[idx] : ""}
            active={active}
            onChange={(v: { target: { value: SetStateAction<string> } }) =>
              updateOfferRowData("DATES", v.target.value, idx)
            }
          />
        ));
      case 2:
        return (
          <div className="wrapBoxMini" style={{ padding: 0 }}>
            {temp.DAYS &&
              Array.isArray(temp.DAYS) &&
              temp.DAYS.map((e: Array<string>, idx: number) => (
                <div
                  key={idx}
                  className="miniButton noSelect wrapBoxMini"
                  style={{
                    position: "relative",
                    backgroundColor: colors.grey,
                    overflow: "hidden",
                    paddingRight:
                      e.length === 1 && !emptys.includes(e[0]) ? 25 : undefined,
                  }}
                >
                  {e.map((o: string, idx2: number) => (
                    <OfferDay
                      key={idx2}
                      index={idx}
                      innerIndex={idx2}
                      day={o}
                      updateOfferRowData={updateOfferRowData}
                    />
                  ))}
                  {e.length === 1 && !emptys.includes(e[0]) && (
                    <>
                      <NavigateNextIcon
                        onClick={() => {
                          dateRef.current && dateRef.current.showPicker();
                        }}
                        style={{
                          position: "absolute",
                          right: 0,
                          top: 1,
                          backgroundColor: colors.green,
                          fontSize: 20,
                        }}
                      />
                      <input
                        ref={dateRef}
                        type="date"
                        onChange={(v) => {
                          const mCode = emptys.includes(v.target.value)
                            ? v.target.value
                            : v.target.value
                                .split("-")
                                .map((o: string, idx: number) => (idx ? o : ""))
                                .join("-")
                                .slice(1);
                          console.log("mCode", mCode);
                          updateOfferRowData("DAYS", mCode, [idx, 1]);
                        }}
                        style={{
                          position: "absolute",
                          width: 0,
                          opacity: 0,
                        }}
                      />
                    </>
                  )}
                </div>
              ))}
            <div
              className="miniButton noSelect"
              style={{ backgroundColor: colors.green }}
              onClick={() => updateOfferRowData("DAYS", [""])}
            >
              {t("p.add")}
            </div>
          </div>
        );
      case 3:
        return (
          <div style={{ display: "flex", flexDirection: "row" }}>
            {Array.from({ length: 7 }, (_, idx) => (
              <BasicInput
                key={idx}
                label={t(`p.d${idx}m`)}
                type={"checkbox"}
                value={temp.WEEK && temp.WEEK[idx] ? temp.WEEK[idx] : 0}
                style={{ display: "flex", flexDirection: "row" }}
                active={active}
                onChange={() =>
                  updateOfferRowData(
                    "WEEK",
                    temp.WEEK ? (temp.WEEK[idx] === 1 ? 0 : 1) : 1,
                    idx,
                  )
                }
              />
            ))}
          </div>
        );
      default:
        return <></>;
    }
  };

  return (
    <tr>
      <td valign="top" style={{ width: 20 }}>
        {
          <BasicInput
            type={"checkbox"}
            value={temp.ACTOFE}
            active={active}
            onChange={() =>
              updateOfferRowData("ACTOFE", temp.ACTOFE === "1" ? "0" : "1")
            }
          />
        }
      </td>
      <td valign="top" style={{ width: 50 }}>
        <BasicInput
          type={"select"}
          value={temp.TAROFE}
          active={active}
          options={[
            { label: t("p.all"), value: "0" },
            ...pricesRates.map((e: stdObject) => ({
              label: e.NOMTAR,
              value: e.CODTAR,
            })),
          ]}
          onChange={(v: { target: { value: SetStateAction<string> } }) =>
            updateOfferRowData("TAROFE", v.target.value)
          }
        />
        <BasicInput
          type={"select"}
          value={temp.DATOFE}
          active={active}
          options={[
            { label: t("p.always"), value: 0 },
            { label: t("p.date"), value: 1 },
            { label: t("p.fixedDate"), value: 2 },
            { label: t("p.week"), value: 3 },
          ]}
          onChange={(v: { target: { value: SetStateAction<string> } }) =>
            updateOfferRowData("DATOFE", v.target.value)
          }
        />
      </td>
      <td valign="top">{datesInputs()}</td>
      <td valign="top" style={{ width: 50 }}>
        <BasicInput
          type={"select"}
          value={temp.TIPOFE}
          active={active}
          options={[
            { label: t("p.price"), value: "0" },
            { label: t("p.discount"), value: "1" },
          ]}
          onChange={(v: { target: { value: SetStateAction<string> } }) =>
            updateOfferRowData("TIPOFE", v.target.value)
          }
        />
        <BasicInput
          type={"number"}
          value={Number(temp.TIPOFE) === 1 ? temp.POROFE : temp.PREOFE}
          active={active}
          innerStyle={{ width: 50 }}
          suffix={Number(temp.TIPOFE) === 1 ? "%" : ""}
          onChange={(v: { target: { value: SetStateAction<string> } }) =>
            updateOfferRowData(
              Number(temp.TIPOFE) === 1 ? "POROFE" : "PREOFE",
              v.target.value,
            )
          }
        />
      </td>
      <td valign="top" style={{ width: 20 }}>
        {
          <DeleteForeverIcon
            style={{ color: colors.red, cursor: "pointer" }}
            onClick={() =>
              deleteOffer(country, index, { windowValues2, setWindowValues2 })
            }
          />
        }
      </td>
    </tr>
  );
}
